module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/point05_06_sunset-17fd12af9f8234b6f3eccc051e5997bd.jpg";